import { computed, watch } from "vue";
import { useStore } from "vuex";
import { IS_AUTH_BUILD_TARGET } from "@/config/index.js";
import { useLocale, type Locale } from "@/composables/useLocale";
import { createPollers } from "@/lib/polling/pollers";
import { startPolling } from "@/lib/polling/scheduler";

export function setupPostLogin() {
  if (IS_AUTH_BUILD_TARGET) {
    return;
  }

  const store = useStore();

  const { changeLocaleLocally } = useLocale();

  const onUserReady = async (
    newUser: { id: number; locale: string } | null,
    oldUser: { id: number } | null,
  ) => {
    if (!newUser || oldUser?.id === newUser.id) {
      return;
    }

    changeLocaleLocally(newUser.locale as Locale);

    const promises: Promise<unknown>[] = [];

    promises.push(store.dispatch("auth/getTermsUrlsForUser"));

    if (!store.getters["auth/isExternalUser"]) {
      promises.push(store.dispatch("institutions/fetchInstitutionsIdsWithHiddenGrammages"));
    }

    promises.push(startPolling(createPollers(store)));

    await Promise.all(promises);
  };

  const user = computed(() => store.getters["auth/user"]);

  watch(user, onUserReady);

  if (user.value) {
    onUserReady(user.value, null);
  }
}
